module.exports = __webpack_public_path__ + "static/media/2023_TalonJones_resume.d89f8ad5.pdf";